import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';

@doc.path('/place_statuses/{?id}')
abstract class AbstractPlaceStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_PlaceStatusReference;
}

export default AbstractPlaceStatusModel;
